import moment from "moment";

import UtilityService from "../../services/UtilityService";
import { STATUSES } from "../../constants/Tasks";

const { toDateOnly } = UtilityService;

export function userFullName(user) {
	if (!user) {
		return "";
	}

	return `${user.first_name || ""} ${user.last_name || ""}`.trim();
}

export function initialsOf(name) {
	return String(name || "")
		.split(" ")
		.filter(Boolean)
		.map(part => part[0])
		.join("")
		.slice(0, 2)
		.toUpperCase();
}

export function pluralize(count, word) {
	return `${count} ${word}${count === 1 ? "" : "s"}`;
}

export function deadlineMoment(task) {
	const dateOnly = toDateOnly({ value: task.deadline });

	return dateOnly ? moment(dateOnly, "YYYY-MM-DD") : null;
}

// Which due-date bucket a task falls in, using the same Sunday-to-Saturday weeks as the deadline board and the API presets
export function dueBucket(task) {
	const deadline = deadlineMoment(task);

	if (!deadline) {
		return "none";
	}

	const today = moment().startOf("day");
	const diff = deadline.diff(today, "days");

	if (diff < 0) {
		return "overdue";
	}

	if (diff === 0) {
		return "today";
	}

	const endOfWeek = today.clone().endOf("week");

	if (!deadline.isAfter(endOfWeek)) {
		return "thisWeek";
	}

	if (!deadline.isAfter(endOfWeek.clone().add(7, "days"))) {
		return "nextWeek";
	}

	return "afterNextWeek";
}

export function dueMeta(task) {
	const deadline = deadlineMoment(task);

	if (!deadline) {
		return { meta: "No due date", tone: "none" };
	}

	if (task.status === STATUSES.done.id) {
		return { meta: "Completed", tone: "done" };
	}

	const diff = deadline.diff(moment().startOf("day"), "days");

	if (diff < 0) {
		return { meta: `${pluralize(-diff, "day")} overdue`, tone: "overdue" };
	}

	if (diff === 0) {
		return { meta: "Due today", tone: "today" };
	}

	const bucket = dueBucket(task);

	return { meta: diff === 1 ? "Tomorrow" : `In ${diff} days`, tone: bucket === "thisWeek" ? "soon" : "later" };
}

export function isSequential(task) {
	return !!(task.Engagement && task.Engagement.sequential_tasks);
}

export function isInactiveEngagement(task) {
	return !!(task.Engagement && task.Engagement.flow_state && task.Engagement.flow_state.status && task.Engagement.flow_state.status !== "active");
}

// Normalises the different shapes the client search endpoint can answer with
export function toArray(result) {
	if (Array.isArray(result)) {
		return result;
	}

	if (result && Array.isArray(result.data)) {
		return result.data;
	}

	if (result && result.data && Array.isArray(result.data.rows)) {
		return result.data.rows;
	}

	return [];
}
